module.exports = __webpack_public_path__ + "static/media/Fiji - FJ.5e342512.png";